module.exports = __webpack_public_path__ + "img/case-logo-6.3c021dd6.png";